import { createSlice } from '@reduxjs/toolkit';

import { GetReturnType } from '../types/getReturnType';

export interface IUserState {
  userId: number | null;
  anonymousUserId: string | null;
  isAuthenticatedByRedirect: boolean;
}

export const userInitialState: IUserState = {
  userId: null,
  anonymousUserId: null,
  isAuthenticatedByRedirect: false,
};

// Данные пользователя
export const userSlice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {},
});

export type TUserSlice = GetReturnType<typeof userSlice.actions>;
